import { useHistory, useLocation } from 'react-router-dom';

export const useQueryParam = <T extends string>(paramName: string, defaultValue: T): [T, (newValue: T) => void] => {
    const history = useHistory();
    const location = useLocation();

    const queryParams = new URLSearchParams(location.search);
    const value = queryParams.get(paramName) as T | null;
    const setValue = (newValue: T) => {
        const params = new URLSearchParams(location.search);
        params.set(paramName, newValue);
        history.push({ search: params.toString() });
    };

    return [value ?? defaultValue, setValue];
};
